<template>
    <div id="msg-box-2">
      <div id="msg-text-2">
        {{msg}}
      </div>
    </div>
</template>

<script>
export default {
  name: 'GotMsg',
  props: {
    msg: String
  }
}
</script>

<style>
#msg-box-2{
    float:left;
    background: #FF5C5C;
    padding-left:2%;
    border-top-right-radius: 20px; 
    border-bottom-left-radius: 20px; 
    border-bottom-right-radius: 20px;
    margin:1%;
}
#msg-text-2{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    text-align: left;
    padding: 15px;

    color: #FFFFFF;
    padding: 15px;
}
</style>